import { Injectable } from '@angular/core';

@Injectable()
export class MaintenanceModeService {
  private dateFormatOptions: Intl.DateTimeFormatOptions;
  private isMaintenanceModeActive = false;
  private retryAfterDate: string;

  set isMaintenanceMode(isActive: boolean) {
    this.isMaintenanceModeActive = isActive;
  }

  get isMaintenanceMode() {
    return this.isMaintenanceModeActive;
  }

  set retryAfter(date: string) {
    let shortDate: Date;

    if (date) {
      shortDate = new Date(date);
    } else {
      shortDate = new Date();
      shortDate.setMinutes(shortDate.getMinutes() + 30);
    }

    this.retryAfterDate = shortDate.toLocaleTimeString(undefined, this.dateFormatOptions);
  }

  get retryAfter() {
    return this.retryAfterDate;
  }
}
